import Tooltip from './Tooltip.react';

export default Tooltip;
export type {TooltipRef, TooltipProps} from './Tooltip.react';
